module.exports = require("eslint-plugin-no-unsanitized");